import axios from "axios";
import { Booking } from "../../../types/BookingWithCert";
import { createShortDate } from "../createShortDate";
import { parseBookingDate } from "../parseBookingDate";

export const getAllBookings = async ({
  getToken,
  serverURL,
  setFutureBookings,
  setPastBookings,
  setLoading,
  setSearch,
}: any) => {
  try {
    if (getToken) {
      const token = await getToken();
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await axios.post(
        `${serverURL}/all-bookings`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const today = new Date();
      const pastBookingsTemp: Booking[] = [];
      const futureBookingsTemp: Booking[] = [];

      response.data.forEach((booking: Booking) => {
        const bookingDate = parseBookingDate(booking.date);
        booking.shortDate = createShortDate(bookingDate);
        if (bookingDate < today || booking.cancelled) {
          pastBookingsTemp.push(booking);
        } else {
          futureBookingsTemp.push(booking);
        }
      });

      futureBookingsTemp.sort((a, b) => {
        const dateA = parseBookingDate(a.date).getTime();
        const dateB = parseBookingDate(b.date).getTime();
        return dateA - dateB;
      });

      setPastBookings(pastBookingsTemp);
      setFutureBookings(futureBookingsTemp);
      setLoading(false);
      setSearch((prev: any) => ({
        ...prev,
        listPastBookings: pastBookingsTemp,
        listFutureBookings: futureBookingsTemp,
      }));
    } else {
      setLoading(false);
    }
  } catch (err) {
    console.log(err);
    setLoading(false);
  }
};

export const getFutureBookingsPaginated = async ({
  getToken,
  serverURL,
  page,
  limit = 10,
}: any) => {
  const token = await getToken();
  const response = await axios.post(
    `${serverURL}/admin/future-bookings`,
    { page, limit },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const bookings: Booking[] = response.data.data.map((booking: Booking) => {
    booking.shortDate = createShortDate(parseBookingDate(booking.date));
    return booking;
  });
  return { bookings, pagination: response.data.pagination };
};

export const getPastBookingsPaginated = async ({
  getToken,
  serverURL,
  page,
  limit = 10,
}: any) => {
  const token = await getToken();
  const response = await axios.post(
    `${serverURL}/admin/past-bookings`,
    { page, limit },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const bookings: Booking[] = response.data.data.map((booking: Booking) => {
    booking.shortDate = createShortDate(parseBookingDate(booking.date));
    return booking;
  });
  return { bookings, pagination: response.data.pagination };
};

export const getFutureRemedialBookingsPaginated = async ({
  getToken,
  serverURL,
  page,
  limit = 10,
}: any) => {
  const token = await getToken();
  const response = await axios.post(
    `${serverURL}/admin/future-remedial-bookings`,
    { page, limit },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const bookings: Booking[] = response.data.data.map((booking: Booking) => {
    booking.shortDate = createShortDate(parseBookingDate(booking.date));
    return booking;
  });
  return { bookings, pagination: response.data.pagination };
};

export const getPastRemedialBookingsPaginated = async ({
  getToken,
  serverURL,
  page,
  limit = 10,
}: any) => {
  const token = await getToken();
  const response = await axios.post(
    `${serverURL}/admin/past-remedial-bookings`,
    { page, limit },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const bookings: Booking[] = response.data.data.map((booking: Booking) => {
    booking.shortDate = createShortDate(parseBookingDate(booking.date));
    return booking;
  });
  return { bookings, pagination: response.data.pagination };
};
